
import { Visibility, Print, Paid, Edit, Delete, RequestQuote, PeopleAlt, QrCodeScanner, Category,LocalShippingRounded, SettingsSuggest, Addchart, Balance, PhotoCamera, Description, LoyaltyOutlined, RequestQuoteOutlined, CurrencyExchangeOutlined, QueryStatsOutlined, ReceiptLong, PieChartOutline, MonetizationOnOutlined, AddOutlined, PersonOutlineOutlined, EmailOutlined, TaskAltOutlined, CommentOutlined, PowerSettingsNew, StoreOutlined, FindInPageRounded, CheckCircleRounded, CancelRounded, SyncAltOutlined, Timeline, BarChart, PointOfSale, AccountCircle, PlayCircleFilled, StopCircle, FormatListNumbered, Search, SignalCellularAlt, Add, ArrowBack, Plagiarism, Engineering, ManageAccounts, GroupAdd, Info, CameraAlt, ProductionQuantityLimits, CloudUpload, Downloading, ShoppingCartCheckout, Widgets, Drafts, Archive, HealthAndSafety, RememberMe, SaveAs, ShoppingCart, Signpost, PersonAdd, MarkunreadMailbox, Send, LockPerson, Inventory, Logout, AdminPanelSettings, Inventory2 } from '@mui/icons-material';




export const iconos = {

    persona: <PersonOutlineOutlined sx={{fontSize:'17px'}}/>,
    email: <EmailOutlined sx={{fontSize:'17px'}}/>,
    tarea: <TaskAltOutlined sx={{fontSize:'17px'}}/>,
    comentario: <CommentOutlined sx={{fontSize:'17px'}}/>,
    cerrar: <PowerSettingsNew sx={{fontSize:'17px'}}/>,
    
    archivado: <Archive />,
    abono: <Paid />,
    agregar: <AddOutlined />,
    apertura: <PlayCircleFilled />,
    aprobado: <CheckCircleRounded />,
    back: <ArrowBack />,
    busqueda: <Search />,
    camara: <CameraAlt />,
    categoria: <Category />,
    cierre: <StopCircle />,
    cliente: <GroupAdd />,
    colaborador: <Engineering />,
    comercial: <LocalShippingRounded />,
    comprar: <ShoppingCartCheckout />,
    carrito: <ShoppingCart />,
    compras: <ProductionQuantityLimits />,
    comprobante: <PhotoCamera/>,
    descargar: <Downloading />,
    desprese: <Balance />,
    detalles: <Plagiarism />,
    editar: <Edit />,
    eliminar: <Delete color='error'/>,
    error: <CancelRounded />,
    factura: <ReceiptLong />,
    gasto: <CurrencyExchangeOutlined />,
    gasto1: <CurrencyExchangeOutlined />,
    historico: <Timeline />,
    imprimir: <Print />,
    informacion: <Info />,
    informe: <Addchart />,
    infotablas: <PieChartOutline />,
    inventario: <FindInPageRounded />,
    menu: <FormatListNumbered />,
    micuente: <ManageAccounts />,
    pedidos: <Widgets />,
    planilla: <Description />,
    plus: <Add />,
    presas: <Balance />,
    producto: <QrCodeScanner />,
    pronostico: <LoyaltyOutlined />,
    proveedor: <AccountCircle />,
    remision: <RequestQuoteOutlined />,
    separar: <Balance />,
    settings: <SettingsSuggest />,
    store: <StoreOutlined />,
    subirimg: <CloudUpload />,
    tabla: <QueryStatsOutlined />,
    tablas: <BarChart />,
    totales: <SignalCellularAlt />,
    traslado: <SyncAltOutlined />,
    user: <PeopleAlt />,
    valor: <RequestQuote/>,
    vender: <PointOfSale />,
    ventas: <MonetizationOnOutlined />,
    ver: <Visibility />,
    mensaje: <Drafts />,
    seguridad: <HealthAndSafety />,
    carnet: <RememberMe />,
    save: <SaveAs />,
    trasabilidad: <Signpost />,
    asignar: <PersonAdd />,
    entregar: <MarkunreadMailbox />,
    entrega: <Send />,
    password: <LockPerson />,
    materiaPrima: <Inventory />,
    salida: <Logout />,
    admin: <AdminPanelSettings />,
    lotes: <Inventory2 />,

}